import { MeetupBtn, VisitUsBtn } from "../styles/Buttons";
import { ContentWrapper, MeetupAndVisitWrapper, MeetupWrapper, TextWrapper } from "../styles/Layouts";
import { MeetupText, Slogan, Subtitle, Title } from "../styles/Typography";

const Hero = () => {
  return (
    <ContentWrapper>
      <Title>hey, we are charcha:)</Title>
      <TextWrapper>
        <Subtitle>making coffee breaks tastier while sparking curiosity</Subtitle>
        <Slogan>freshly brewed coffee, ideas, art.</Slogan>
      </TextWrapper>

      <MeetupAndVisitWrapper>
        <MeetupWrapper>
          <MeetupText>Check out our events here: </MeetupText>
          <MeetupBtn href="https://www.meetup.com/charcha-cultural-cafe/" target="_blank" rel="noopener noreferrer">
            meetup
          </MeetupBtn>
        </MeetupWrapper>

        <VisitUsBtn href="https://maps.app.goo.gl/We6mFy9Tk2vEgV9o7" target="_blank" rel="noopener noreferrer">
          VISIT US
        </VisitUsBtn>
      </MeetupAndVisitWrapper>
    </ContentWrapper>
  );
};

export default Hero;
